import * as React from 'react';

import { FormattedMessage, InjectedIntlProps } from 'react-intl';

import { Button } from 'components/Button';
import { Form } from 'components/Form';
import { FieldFile, FieldText, InputFile, InputText } from 'components/Input';
import { APPLICATION_FORM_NAME } from 'constants/app';
import { validate } from 'helper/validation/account/accountStoreForm';
import { AccountStoreForm as AccountStoreFormModel } from 'models/account';

import './AccountStoreForm.scss';

interface AccountStoreFormProps extends InjectedIntlProps {
  initialValues?: AccountStoreFormModel;
  onSubmit: (accountStoreForm: AccountStoreFormModel) => void;
}

export class AccountStoreForm extends React.Component<AccountStoreFormProps, {}> {
  private fieldName: FieldText;

  constructor(props: AccountStoreFormProps) {
    super(props);

    this.setFieldNameReference = this.setFieldNameReference.bind(this);
  }

  componentDidMount() {
    if (!this.props.initialValues || (this.props.initialValues && !this.props.initialValues.name)) {
      (this.fieldName.getRenderedComponent() as InputText).focus();
    }
  }

  render() {
    const { initialValues, onSubmit } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <Form
        form={APPLICATION_FORM_NAME}
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        <FieldFile
          className="o-form-field"
          component={InputFile}
          icon="ic-camera"
          label={formatMessage({ id: 'account.store.form.upload.image.button' })}
          name="avatar"
        />
        <FieldText
          className="o-form-field"
          component={InputText}
          label={formatMessage({ id: 'account.store.form.name' })}
          modifier="cancel"
          name="name"
          ref={this.setFieldNameReference}
          type="text"
          withRef={true}
        />
        <FieldText
          className="o-form-field"
          component={InputText}
          label={formatMessage({ id: 'account.store.form.url' })}
          footnote={formatMessage({ id: 'account.store.form.url.format' })}
          modifier="cancel"
          name="url"
          type="text"
        />
        <FieldText
          className="o-form-field"
          component={InputText}
          label={formatMessage({ id: 'account.store.form.address' })}
          footnote={formatMessage({ id: 'account.store.form.address.format' })}
          modifier="cancel"
          name="address"
          type="text"
        />

        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="account.store.form.button"/>
        </Button>
      </Form>
    );
  }

  private setFieldNameReference(field: FieldText) {
    this.fieldName = field;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AccountStoreForm/AccountStoreForm.tsx